function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

/* icon/UI 24px/Mental Health Small (self care, head).svg: width 24px x height 24px */
var DlsIconMentalHealthSmall =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsIconMentalHealthSmall, _CustomElement2);

  function DlsIconMentalHealthSmall() {
    _classCallCheck(this, DlsIconMentalHealthSmall);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconMentalHealthSmall).apply(this, arguments));
  }

  _createClass(DlsIconMentalHealthSmall, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 24 24\"><path stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M15.537 6.99a2.428 2.428 0 00-1.74-.74c-.652 0-1.277.266-1.738.74l-.805.84-.806-.84a2.428 2.428 0 00-1.739-.74c-.652 0-1.277.266-1.739.74a2.556 2.556 0 00-.72 1.783c0 .67.26 1.31.72 1.784l4.276 4.304 3.478-3.485.806-.826a2.569 2.569 0 00.007-3.56z\" clip-rule=\"evenodd\"/><path stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"1.5\" d=\"M15.25 23.5v-3.343c0-.612.618-1.157 1.25-1.157h2c.787-.019 1.366-.585 1.386-1.347l-.023-2.645 1.583-.918c.274-.161.365-.499.264-.794L19.335 6.81C18.162 3.718 16 1.25 11.75 1.25s-6.881 1.87-8.5 4.766c-1.619 2.897-1.001 6.371 1.058 8.992 1.389 1.827 1.975 4.079 1.942 6.347V23.5\"/></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-mental-health-small';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconMentalHealthSmall;
}(_CustomElement);

export { DlsIconMentalHealthSmall as default };
DlsIconMentalHealthSmall.define();